export const getParkrunnerData = () => {
    return [
        { 
            id: 6488988, 
            type: 'athlete',
            name: 'Jeffrey Stamborski', 
            nickname: 'Goddammit', 
            parrotType: 'jeff' 
        },
        { 
            id: 12036587, 
            type: 'athlete',
            name: 'Nicole Jordan',
            nickname: 'Grape Soda', 
            parrotType: 'wizard' 
        },
        { 
            id: 46740, 
            type: 'club',
            name: 'Queensland Inline Hockey', 
            nickname: 'QLD Hockey', 
            parrotType: 'australia' 
        }
    ];
}